import { render, staticRenderFns } from "./ViewHealthcare.vue?vue&type=template&id=a40cb434&scoped=true&"
import script from "./ViewHealthcare.vue?vue&type=script&lang=js&"
export * from "./ViewHealthcare.vue?vue&type=script&lang=js&"
import style0 from "./ViewHealthcare.vue?vue&type=style&index=0&id=a40cb434&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a40cb434",
  null
  
)

export default component.exports